const mediaItems = [
  {
    id: 1,
    image: 'https://readdy.ai/api/search-image?query=Sci-fi%20comic%20book%20preview%20panel%20showing%20epic%20space%20battle%20scene%20giant%20mecha%20fighting%20alien%20monster%20dramatic%20action%20dynamic%20composition%20comic%20art%20style%20warm%20colored%20explosions%20detailed%20illustration&width=800&height=450&seq=media-preview-1&orientation=landscape',
    title: '《星甲战神》动画PV首发',
    desc: '人气漫画《星甲战神》动画化决定！首支预告片震撼公开，巨型机甲与异星巨兽的巅峰对决即将搬上荧幕。',
    tag: '动画化',
    date: '2026.07.28',
  },
  {
    id: 2,
    image: 'https://readdy.ai/api/search-image?query=Sci-fi%20comic%20style%20illustration%20author%20interview%20scene%20famous%20manga%20artist%20at%20drawing%20desk%20surrounded%20by%20sketches%20of%20spaceships%20and%20aliens%20warm%20studio%20lighting%20creative%20atmosphere&width=800&height=450&seq=media-preview-2&orientation=landscape',
    title: '专访《银河远征队》作者 · 创作幕后',
    desc: '独家对话连载五年的星际漫画大师，听他讲述宇宙世界观构建过程中的灵感来源与创作心得。',
    tag: '作者专访',
    date: '2026.07.25',
  },
  {
    id: 3,
    image: 'https://readdy.ai/api/search-image?query=Sci-fi%20comic%20convention%20scene%20crowd%20of%20cosplayers%20in%20space%20armor%20large%20banners%20of%20popular%20space%20comics%20vibrant%20atmosphere%20warm%20convention%20hall%20lighting%20excited%20fans&width=800&height=450&seq=media-preview-3&orientation=landscape',
    title: '2026 银河漫展 · 星球漫画专区回顾',
    desc: '今年银河漫展上星球漫画展区盛况空前，多部新作首发签售、限定周边引发粉丝排队热潮。',
    tag: '漫展速报',
    date: '2026.07.20',
  },
];

export default function Media() {
  return (
    <section id="media" className="py-12 md:py-16 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-8 md:mb-10">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-2">
            精彩预告
          </h2>
          <p className="text-sm text-foreground-500 max-w-md mx-auto">
            动画化、作者专访、漫展资讯一手掌握
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-6">
          {mediaItems.map((item) => (
            <a
              key={item.id}
              href="#media"
              className="group bg-background-50 rounded-lg overflow-hidden border border-background-200/60 hover:border-accent-300/50 transition-colors no-underline block cursor-pointer"
            >
              <div className="relative w-full h-44 md:h-48 overflow-hidden">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover object-top"
                />
                <div className="absolute inset-0 flex items-center justify-center bg-foreground-950/20 group-hover:bg-foreground-950/30 transition-colors">
                  <span className="w-12 h-12 md:w-14 md:h-14 rounded-full bg-background-50/90 flex items-center justify-center">
                    <i className="ri-play-fill text-primary-500 text-xl md:text-2xl ml-0.5"></i>
                  </span>
                </div>
                <span className="absolute top-3 left-3 bg-accent-500 text-background-50 text-xs font-semibold px-2.5 py-1 rounded-full whitespace-nowrap">
                  {item.tag}
                </span>
              </div>
              <div className="p-3 md:p-4">
                <h3 className="text-sm md:text-base font-heading font-bold text-foreground-900 mb-1.5 leading-snug group-hover:text-primary-600 transition-colors">
                  {item.title}
                </h3>
                <p className="text-xs md:text-sm text-foreground-500 leading-relaxed mb-2 line-clamp-2">
                  {item.desc}
                </p>
                <p className="text-xs text-foreground-400 whitespace-nowrap">{item.date}</p>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}